<p-panel>
    <ng-container *ngIf="isReactiveFormReady; else reactiveFormLoadingState">
        @if (isPastoreoSelected()) {
            <div class="d-flex w-100 justify-content-end mb-3">
                <button class="btn btn-primary" type="button" (click)="showDialogUploadFile = true">
                    {{ optionsUploadFile.uploaded ? 'Ver Archivo' : 'Subir Archivo' }}
                </button>
            </div>
        }

        <app-reactive-form-builder
            (goBack)="goBack()"
            (internalLifecycleEvents)="onReactiveFormLifecycleEvent($event)"
            (stableValueChanges)="stableValueChanges($event)"
            [form]="form.formFields"
            [getRequest]="getRequest"
            [id]="reactiveFormRecordId"
            [previousData]="initialPreviousData"
            [request]="request"
            [undoEnabled]="undoEnabled">
        </app-reactive-form-builder>
    </ng-container>
</p-panel>

<ng-template #reactiveFormLoadingState>
    <div class="p-3 text-center" role="status" aria-live="polite">
        <div *ngIf="!reactiveFormLoadingError" class="text-muted">
            {{ reactiveFormLoadingLabel }}
        </div>
        <div *ngIf="reactiveFormLoadingError" class="alert alert-danger mb-0" role="alert">
            {{ reactiveFormLoadingError }}
        </div>
    </div>
</ng-template>

<app-upload-file
    [showUploadDialog]="showDialogUploadFile"
    [options]="optionsUploadFile"
    (eventClose)="showDialogUploadFile = false"
    (namesFilesOutput)="handleUploadedFileNamesChange($event)">
</app-upload-file>
